/**
 * Return element's offset width and height
 *
 * @param element HTMLElement to measure
 */
export function getElementOffsetDimensions(element: HTMLElement): { width: number; height: number } {
    return {
        width: element.offsetWidth,
        height: element.offsetHeight,
    };
}
